import { cn } from "@/utils/cn";
import { IonIcon } from "@ionic/react";
import { checkmarkOutline } from "ionicons/icons";
import { memo } from "react";

interface SubscriptionUpgradeOptionCardProps {
  title: string;
  priceString: string;
  billingFrequency: string;
  discountText?: string;
  isSelected: boolean;
  isDisabled?: boolean;
  onClick: () => void;
}

export const SubscriptionUpgradeOptionCard = memo(function SubscriptionUpgradeOptionCard({
  title,
  priceString,
  billingFrequency,
  discountText,
  isSelected,
  isDisabled,
  onClick,
}: SubscriptionUpgradeOptionCardProps) {
  const isYearly = discountText != null;

  const description = isYearly && discountText
    ? `${discountText.charAt(0).toUpperCase()}${discountText.slice(1)} vs monthly, billed yearly`
    : billingFrequency;

  return (
    <div className={cn("relative w-full", isYearly && "pt-5")}>
      {isYearly && (
        <div className="absolute top-0 left-1/2 z-10 -translate-x-1/2 rounded-full bg-[#620ad5] px-2.5 py-1.5">
          <span className="whitespace-nowrap text-sm font-medium text-white">Best value</span>
        </div>
      )}

      <button
        type="button"
        onClick={onClick}
        disabled={isDisabled}
        className={cn(
          "relative w-full flex flex-col items-start gap-1 rounded-[22px] border p-3 text-left",
          "bg-white drop-shadow-[0px_8px_32.35px_rgba(64,0,255,0.1)]",
          "transition-colors",
          isDisabled && "cursor-not-allowed opacity-70",
          isSelected ? "border-[#620ad5]" : "border-black",
        )}
      >
        {isSelected && (
          <div className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-[#620ad5]">
            <IonIcon icon={checkmarkOutline} className="text-lg text-white" />
          </div>
        )}

        <span
          className={cn(
            "text-2xl font-bold leading-tight",
            isSelected ? "text-[#620ad5]" : "text-black",
          )}
        >
          {title}
        </span>

        <span
          className={cn(
            "text-[32px] font-bold leading-tight",
            isSelected ? "text-[#620ad5]" : "text-black",
          )}
        >
          {priceString}
        </span>

        <span
          className={cn(
            "text-xs font-medium leading-5",
            isSelected ? "text-[#620ad5]" : "text-black",
          )}
        >
          {description}
        </span>
      </button>
    </div>
  );
});
